import React from 'react';

export default function ClosedView() {
  return (
    <div className="flex-1 flex flex-col items-center justify-center p-6 text-center">
      <div className="max-w-md w-full">
        <p className="font-display text-[11px] uppercase tracking-[0.15em] text-navy/60 mb-6">
          Access closed
        </p>
        <h1 className="font-display text-3xl font-semibold mb-6">
          The window has closed.
        </h1>
        <p className="text-lg mb-4">
          Key Advisor Bot was open until 31 August 2026.
        </p>
        <p className="text-navy/80 leading-relaxed mb-10">
          The same scripts, frameworks and AI coach live inside The Manager Key — the difference is it does not expire.
        </p>
        
        <a 
          href="https://member.keyfutureskills.com"
          className="inline-flex items-center justify-center px-6 py-3 border border-navy font-display text-sm font-medium hover:bg-navy hover:text-cream transition-colors duration-200 mb-8 w-full sm:w-auto"
        >
          See The Manager Key
        </a>

        <div>
          <a 
            href="https://www.keyfutureskills.com"
            className="font-display text-xs text-navy/50 hover:text-navy transition-colors"
          >
            Return to KeyFutureSkills
          </a>
        </div>
      </div>
    </div>
  );
}